import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule, Routes } from '@angular/router';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatButtonModule, MatIconModule } from '@angular/material';
import { InMemoryWebApiModule } from 'angular-in-memory-web-api';
import { TranslateModule } from '@ngx-translate/core';
import 'hammerjs';

// Firebase Modules
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFireStorageModule  } from "@angular/fire/storage";
import { environment } from '../environments/environment';

import { FuseModule } from '@fuse/fuse.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { FuseProgressBarModule, FuseSidebarModule, FuseThemeOptionsModule } from '@fuse/components';

import { fuseConfig } from 'app/fuse-config';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { AppComponent } from 'app/app.component';
import { LayoutModule } from 'app/layout/layout.module';
import { SampleModule } from 'app/main/sample/sample.module';

import { UserResolver } from "./main/sample/user.resolver";
import { UserService } from './core/user.service';
import { AuthGuard } from "./core/auth.guard";

import { AppStoreModule } from 'app/store/store.module';

import { FakeDbService } from 'app/fake-db/fake-db.service';

import { Store } from "../store";

const appRoutes: Routes = [
    {
        path        : 'auth',
        loadChildren: './authentication/authentication.module#AuthenticationModule'
    },
    {
        path        : 'gastos',
        loadChildren: './main/gastos/gastos.module#GastosModule'
    },
    {
        path        : 'prestamos',
        loadChildren: './main/loans/loans.module#LoansModule'
    },
    {
        path        : 'suggests',
        loadChildren: './main/suggest/suggest.module#SuggestModule'
    },
    {
        path        : 'dashboard',
        loadChildren: './main/dashboard/dashboard.module#DashboardModule'
    },
    {
        path        : 'shared',
        loadChildren: './main/shared/shared.module#SharedModule'
    },
    {
        path      : '**',
        redirectTo: 'gastos/finanzas/cuentas'
    }
];

@NgModule({
    declarations: [
        AppComponent
    ],
    imports     : [
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        RouterModule.forRoot(appRoutes),

        TranslateModule.forRoot(),
        InMemoryWebApiModule.forRoot(FakeDbService, {
            delay             : 0,
            passThruUnknownUrl: true
        }),

        AngularFireModule.initializeApp(environment.firebaseConfig), // Main Angular fire module 
        AngularFireDatabaseModule,  // Firebase database module 
        AngularFirestoreModule,
        AngularFireAuthModule,
        AngularFireStorageModule,

        FontAwesomeModule,

        // Material moment date module
        MatMomentDateModule,

        // Material
        MatButtonModule,
        MatIconModule,

        // Fuse modules
        FuseModule.forRoot(fuseConfig),
        FuseProgressBarModule,
        FuseSharedModule,
        FuseSidebarModule,
        FuseThemeOptionsModule,

        // App modules
        LayoutModule,
        SampleModule,

        AppStoreModule
    ],
    providers: [
        UserService,
        UserResolver,
        AuthGuard,
        Store
    ],
    bootstrap   : [
        AppComponent
    ]
})
export class AppModule
{
}
